// no-dd-sa:javascript-code-style/assignment-name,javascript-code-style/parameter-name
import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { groupKeys, isGroupKeyMatched, keysName } from '../../states/Utils';
import _ from 'lodash';
import moment from 'moment';

export const NivoBarChart = ({ view, data }) => {
  // no-dd-sa:javascript-code-style/no-var
  var data = {
    data: data.data.map((group) =>
      view.config.time_format
        ? group.map((d) => ({
            ...d,
            start: moment(d.start).format(view.config.time_format),
          }))
        : group,
    ),
    meta: data.meta,
  };
  const group_by_keys = groupKeys(data, view.config.group_by || []);
  const keys = groupKeys(data, view.config.keys || []);

  const bar_keys = keys.map((k) => keysName(data.meta, k));
  let computed = data.data.map((group) => {
    return group_by_keys.map((group_by_key) => {
      let filtered = group.filter((d) => isGroupKeyMatched(d, group_by_key));
      let obj = { index: keysName(data.meta, group_by_key) };
      keys.forEach((k) => {
        let val = _.sum(filtered.filter((d) => isGroupKeyMatched(d, k)).map((v) => v.value));
        let index = keysName(data.meta, k);
        obj[index] = val;
      });
      return obj;
    });
  });

  return (
    <ResponsiveBar
      pointLabel="y"
      indexBy={'index'}
      keys={bar_keys}
      pointLabelYOffset={-12}
      tooltip={({ id, value, color }) => (
        <span key={id}>
          <span
            style={{
              display: 'inline-block',
              width: 8,
              height: 8,
              marginRight: 6,
              backgroundColor: color,
            }}
          ></span>{' '}
          {id}: {value}
        </span>
      )}
      useMesh={true}
      {...view.config.props}
      data={computed[0]}
    />
  );
};
